var React = require('react');

function ArrowTryIt (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"7.73 1.62 7.73 7.31 1.5 7.31 6.53 10.51 11.56 13.7 16.6 10.51 21.63 7.31 15.63 7.31 15.63 1.5","style":{"fill":"none","stroke":"#fff100","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"}}));
}

ArrowTryIt.defaultProps = {"viewBox":"0 0 23.13 15.2"};

module.exports = ArrowTryIt;

ArrowTryIt.default = ArrowTryIt;
